/**
 * @file Contact Form.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Contact Form component.
 */
const vContactForm = () => {
	const contactForm = document.querySelector('.v-contact-form');

	if (!contactForm) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	/* 	const content = contactForm.querySelector('.v-contact-form__content');
	const animation = gsap.from(content, {
		y:             200,
		ease:          'sine.out',
		scrollTrigger: {
			trigger:         contactForm,
			start:           'top bottom',
			end:             '+=600',
			scrub:           true,
			refreshPriority: -1,
		},
	});

	window.addEventListener('horizontal-scroller-rebuilt', () => {
		setTimeout(() => {
			animation.scrollTrigger.refresh();
		}, 500);
	}); */

	const form = contactForm.querySelector('form');
	const wrap = contactForm.querySelector('.v-contact-form__form-wrap');
	const inputs = contactForm.querySelectorAll('input:not([type="submit"]):not([type="hidden"]), textarea, select');
	let currentAnimation;

	form.addEventListener('focusin', () => {
		if ([...inputs].filter((input) => input.value).length) return;
		if (currentAnimation) currentAnimation.kill();

		currentAnimation = gsap.to(wrap, {
			height:     form.offsetHeight + 20,
			ease:       'sine.out',
			duration:   0.4,
			onComplete: () => {
				wrap.removeAttribute('style');
				wrap.classList.add('v-contact-form__form-wrap--focus');
			},
		});
	});

	form.addEventListener('focusout', () => {
		if ([...inputs].filter((input) => input.value).length) return;
		if (currentAnimation) currentAnimation.kill();

		currentAnimation = gsap.to(wrap, {
			height:     parseInt(getComputedStyle(wrap).getPropertyValue('--field-height'), 10) + 20,
			ease:       'sine.out',
			duration:   0.4,
			onComplete: () => {
				wrap.removeAttribute('style');
				wrap.classList.remove('v-contact-form__form-wrap--focus');
			},
		});
	});
};

export default vContactForm;
